export default __webpack_public_path__ + "static/media/bg-394.c14ae989.png";